import React from "react";
import { apiService } from "../../../utils/api";
import { useParams, useNavigate } from "react-router-dom";
import { FaFileAlt, FaSearch, FaFilter, FaSortAmountDown, FaSortAmountUp, FaPlus, FaEye, FaDownload, FaTrash } from "react-icons/fa";

function AudioExerciseLevels() {
  const [categories, setCategories] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const navigate = useNavigate();

  React.useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiService.getAudioExercises();
        setCategories(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    };
    fetchCategories();
  }, []);

  const handleViewDocument = (id) => {
    navigate(`/dashboard/teacher/document-audio/${id}`);
  };

  return (
    <div className="documents-container">
      <div className="section-header">
        <h2>Select Excerises Levels</h2>
      </div>

      <div className="documents-grid">
        {categories.map((doc) => (
          <div key={doc.id} className="document-card" onClick={() => handleViewDocument(doc.id)}>
            <div className="document-icon">
              <FaFileAlt />
            </div>
            <div className="document-info">
              <h4>{doc.level}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AudioExerciseLevels;
